/**
 * Thang địa chỉ của hồ sơ mộ (SCR-037). Backend dựng `sectionLabel` thành path đọc được
 * ngăn bằng dấu `/` (CTE `section_label` trong `JdbcGraveReadAdapter`), đi từ gốc cây
 * section xuống. UI không suy diễn cấp nào là "khu/lô/hàng": số cấp phụ thuộc cây
 * section của từng nghĩa trang, nên hiển thị đúng số cấp có trong dữ liệu.
 *
 * `positionCode` là cấp cuối (ô), không nằm trong `sectionLabel`.
 */
export type AddressLevel = Readonly<{ key: string; label: string }>;

export function addressLevels(
  sectionLabel: string | null | undefined,
  positionCode: string | null | undefined,
): AddressLevel[] {
  const levels: AddressLevel[] = [];

  const path = typeof sectionLabel === "string" ? sectionLabel : "";
  for (const part of path.split("/")) {
    const label = part.trim();
    if (label !== "") {
      levels.push({ key: `section-${String(levels.length)}`, label });
    }
  }

  const position = typeof positionCode === "string" ? positionCode.trim() : "";
  if (position !== "") {
    levels.push({ key: "position", label: position });
  }

  return levels;
}
